import { IWarehouseAddressDto, WarehouseAddress } from "../../model/warehouse-address";
import moment from "moment";

export interface IGetWhoAmIResponse {
    userName: string;
    accountEmail: string;
    contactData: string;
    warehouseId: string;
    warehouseAddress: IWarehouseAddressDto;
    userDataValidatedAt: string;
}

export class GetWhoAmIResponse {
    private readonly _userName: string;
    private readonly _email: string;
    private readonly _contactData: string;
    private readonly _warehouseCode: string;
    private readonly _warehouse: WarehouseAddress;
    private readonly _userDataValidatedAt: moment.Moment | undefined;

    constructor(dto: IGetWhoAmIResponse) {
        this._userName = dto.userName;
        this._email = dto.accountEmail;
        this._contactData = dto.contactData;
        this._warehouseCode = dto.warehouseId ?? "";
        this._userDataValidatedAt = dto.userDataValidatedAt ? moment(dto.userDataValidatedAt) : undefined;
        if (dto.warehouseAddress) {
            this._warehouse = new WarehouseAddress(dto.warehouseAddress);
        }
    }

    get userName() {
        return this._userName;
    }

    get email() {
        return this._email;
    }

    get contactData() {
        return this._contactData;
    }

    get warehouseCode() {
        return this._warehouseCode;
    }

    get userDataValidatedAt(): moment.Moment | undefined {
        return this._userDataValidatedAt;
    }

    get warehouse() {
        return this._warehouse;
    }
}
